import { render } from "./Chip.vue?vue&type=template&id=9c1ff8d8"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=9c1ff8d8&lang=scss"
script.render = render

export default script